import { render, staticRenderFns } from "./PropertyViewGlobal.vue?vue&type=template&id=06170997&scoped=true"
import script from "./PropertyViewGlobal.vue?vue&type=script&lang=js"
export * from "./PropertyViewGlobal.vue?vue&type=script&lang=js"
import style0 from "./PropertyViewGlobal.vue?vue&type=style&index=0&id=06170997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06170997",
  null
  
)

export default component.exports